import { render } from "./Hero.vue?vue&type=template&id=1a382ca3&scoped=true"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=1a382ca3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a382ca3"]])

export default __exports__